var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list-item',{on:{"click":function($event){return _vm.addSticker(_vm.id)}}},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }